<template>
    <div class="box m-b-0 box-modal">
        <div class="box-header">
            <h3>{{ title }}</h3>
        </div>
        <div class="box-tool">
            <ul class="nav">
                <li class="nav-item inline icon-with-desc">
                    <a class="nav-link text-muted" @click="saveAndExit()">
                        <i class="material-icons md-18">done</i>
                        <span class="icon-desc">CTRL+S</span>
                    </a>
                </li>
                <li class="nav-item inline icon-with-desc">
                    <a class="nav-link text-muted" @click="$emit('close')">
                        <i class="material-icons md-18">clear</i>
                        <span class="icon-desc">ESC</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class="box-body" v-if="isLoading">
            <div class="spinner"/> ładowanie...
        </div>
        <div style="min-height:280px;"  class="box-body" v-else>
            <form class="form-horizontal">
                <div class="row">
                    <div class="col-md-12 col-xs-12 m-b" v-for="(value, key) in schema" :key="'s_'+key">
                        <span v-if="['select', 'select_single', 'select_multiple', 'select_search', 'text', 'textarea', 'date', 'number'].includes(value.type)" class="text-xs text-muted">{{ value.label }}:</span>
                        <input v-if="value.type == 'text'" class="form-control custom-input" type="text" v-model="inputs[key]">
                        <input v-if="value.type == 'number'" class="form-control custom-input" type="number" v-model.number="inputs[key]">
                        <span v-if="value.hint" class="text-xs text-muted m-b-xs" v-html="value.hint"/>

                        <textarea v-if="value.type == 'textarea'" class="form-control m-b" rows="3" v-model="inputs[key]" :placeholder="value.label"/>

                        <label v-if="value.type == 'checkbox'" class="md-check m-b">
                            <input type="checkbox" v-model="inputs[key]">
                            <i class="blue m-r-xs"/>
                            <span class="m-l-xs">{{ value.label }}</span>
                        </label>

                        <div v-if="value.type=='select_single' || value.type == 'select'">
                            <v-select  :placeholder="value.label" style="width:100%;" v-model="inputs[key]"  :options="options[key]" label="label" :reduce="t => t.id"/>
                        </div>
                        <div v-else-if="value.type=='select_multiple'">
                            <v-select multiple="multiple"  :placeholder="value.name" style="width:100%;" v-model="inputs[key]"  :options="options[key]" label="label" :reduce="t => t.id"/>
                        </div>
                        <div v-else-if="value.type=='select_search'">
                            <v-select :placeholder="value.label" style="width:100%;" v-model="inputs[key]" :filterable="false" :options="options[key]" :label="value.optionLabel || 'label'" :reduce="value.reduce || (t => t.id)" @search="(search, loading) => onRemoteSearch(key, search, loading)">
                                <template slot="no-options">{{ value.noOptionsText || 'Zacznij pisać, aby wyszukać...' }}</template>
                                <template v-if="value.optionSlot" slot="option" slot-scope="option">
                                    <div>{{ option[value.optionLabel || 'label'] }}<br v-if="value.optionSublabel"><span v-if="value.optionSublabel" class="text-muted text-sm">{{ option[value.optionSublabel] }}</span></div>
                                </template>
                            </v-select>
                        </div>

                        <!-- kalendarz inline, bo dropdown byłby ucinany przez overflow modala (.v-dialog) -->
                        <div v-if="value.type == 'date'">
                            <div class="m-b-xs text-sm">
                                <span v-if="inputs[key]">Wybrano: <strong>{{ formatDate(inputs[key]) }}</strong></span>
                                <span v-else class="text-muted">Nie wybrano daty</span>
                                <a v-if="inputs[key]" class="text-blue m-l-sm" style="cursor: pointer;" @click="$set(inputs, key, null)">wyczyść</a>
                            </div>
                            <datepicker :language="pl" :monday-first="true" :inline="true" v-model="inputs[key]"/>
                        </div>

                        <p v-if="value.type == 'info'">
                            <strong>{{ value.label }}</strong><br>
                            <span v-if="value.text" v-html="value.text"/>
                        </p>
                    </div>
                </div>
            </form>
        </div>
        <div class="box-footer clearfix">
            <button class="btn white none-radius btn-sm" @click="$emit('close')">Anuluj</button>
            <button
                class="pull-right btn info none-radius btn-sm"
                type="button"
                style="height: 32px;"
                :disabled="isSaving"
                @click="saveAndExit()">
                <div class="spinner" style="display: inline-block; float: left;margin-right: 10px;" v-if="isSaving"/>
                Zapisz
            </button>
        </div>
    </div>
</template>
<script>

/**
 * Okno modalne ogólnego użytku do zbierania danych gdzie w schema możemy podać jakie pola formularza wyświetlić
 * schema {
 *   name: {
 *      label: "Nazwa czegoś",
 *      type: "text|textarea|checkbox|select|number|info",
 *      options: [] || async function <-- jesli type == select
 *   }
 * }
 */

import { deepCopy } from '../Utils';
import Datepicker from 'vuejs-datepicker';
import pl from 'vuejs-datepicker/dist/locale/translations/pl.js'

export default {
    name: 'PromptModal',
    props: {
        title: String,
        schema: {
            type: Object,
            required: true
        },
        values: {
            type: Object,
            required: false
        },
        validate: Function
    },
    components: {
        Datepicker
    },
    data() {
        return {
            pl: pl,
            inputs: {},
            options: {},
            isLoading: false,
            isSaving: false
        }
    },
    created: async function() {
        window.addEventListener('keydown', this.handleKeyUp);

        this.isLoading = true;

        for (const key in this.schema) {
            try {
                if (typeof this.schema[key].options == 'function') {
                    this.$set(this.options, key, await this.schema[key].options());
                } else {
                    this.$set(this.options, key, this.schema[key].options || []);
                }
            } catch (error) {
                console.error(error);
            }
        }

        for (const key in this.values) {
            try {
                if (typeof this.values[key] == 'function') {
                    this.$set(this.inputs, key, await this.values[key]());
                } else {
                    this.$set(this.inputs, key, this.values[key]);
                }

                // Dla select_search: jeśli mamy wartość początkową i initialOption, dodaj ją do opcji
                if (this.schema[key] && this.schema[key].type === 'select_search' && this.values[key] && this.schema[key].initialOption) {
                    const opt = await this.schema[key].initialOption(this.values[key]);
                    if (opt) this.$set(this.options, key, Array.isArray(opt) ? opt : [opt]);
                }
            } catch (error) {
                console.error(error);
            }
        }
        this.isLoading = false;
    },
    destroyed: function() {
        window.removeEventListener('keydown', this.handleKeyUp);
    },
    methods: {

        formatDate(d) {
            const date = new Date(d);
            if (isNaN(date.getTime())) return String(d);
            const pad = n => String(n).padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
        },

        handleKeyUp: function(e) {
            if (e.keyCode == 27) { // ESC
                e.preventDefault();
                this.$emit('close');
            } else if (e.ctrlKey && e.keyCode == 83) { // CTRL+S
                e.preventDefault();
                this.$emit('close', deepCopy(this.inputs));
            }
        },

        /**
         * Obsługuje zdalne wyszukiwanie dla pól typu select_search
         * @param {string} key - klucz pola w schema
         * @param {string} search - fraza wyszukiwania
         * @param {Function} loading - callback sterujący wskaźnikiem ładowania
         */
        async onRemoteSearch(key, search, loading) {
            const field = this.schema[key];
            if (!field || typeof field.search !== 'function') return;
            if (!search || search.length < (field.minSearchLength || 2)) return;
            loading(true);
            try {
                const results = await field.search(search);
                this.$set(this.options, key, results);
            } catch (error) {
                console.error('Remote search error:', error);
            }
            loading(false);
        },

        async saveAndExit() {
            if (typeof this.validate == 'function') {
                this.isSaving = true;
                try {
                    const errors = await this.validate(deepCopy(this.inputs));
                    if (!errors) {
                        this.$emit('close', deepCopy(this.inputs));
                        return;
                    } else {
                        this.$h.errorNotif(errors);
                    }
                } catch (error) {
                    // @todo error notif
                    this.$h.errorNotif(error);
                }
                this.isSaving = false;
            } else {
                this.$emit('close', deepCopy(this.inputs));
            }
        }

    }
}
</script>
